﻿define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def",
	"csi/def/AddPath",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/resolver",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType"
], function(array, declare, lang, csi, def, AddPath, Field, Relationship, Widget, resolver, xml, Query, ProductType) {

	const ID_PARAMETER_FOR_STYLE = "Styles";

	return declare(Widget, {
		FIELD_CREATE_QUOTES: "CreateQuotes",
		FIELD_STYLES: "Styles",
		FIELD_THEME_PRODUCT_ALTERNATIVES: "ThemeProductAlternatives",

		_resolveView: function() {
			var params = {defaultAll: true};

			// summary: add specification and create-quote fields
			this.insertField(lang.mixin(new Field(), {
				m_label: this.FIELD_THEME_PRODUCT_ALTERNATIVES,
				m_typeControl: def.FIELD_MULTI_SELECT,
				widgetParams: params,
				idParameter: "ThemeProductAlternatives",
				m_onChange: "_onChangeProductAlternatives",
				m_relationship: lang.mixin(new Relationship(), {
					m_url: this.getViewURL(),
					m_id: "ThemeProductAlternatives",
					m_query: new Query().Attr("Active", xml.OP_EQUALS, true)
				})
			}));

			this.insertField(lang.mixin(new Field(), {
				m_label: this.FIELD_STYLES,
				m_typeControl: def.FIELD_MULTI_SELECT,
				widgetParams: params,
				idParameter: ID_PARAMETER_FOR_STYLE,
				m_relationship: lang.mixin(new Relationship(), {
					m_typeNode: "Style",
					m_addPaths: [lang.mixin(new AddPath(), {
						m_path: "Parent:Theme"
					})],
					m_query: new Query().Attr("Active", xml.OP_EQUALS, true)
				})
			}));

			this.insertField(lang.mixin(new Field(), {
				m_label: this.FIELD_CREATE_QUOTES,
				m_typeControl: def.FIELD_CHECKBOX,
				idParameter: this.FIELD_CREATE_QUOTES
			}));

			this.inherited(arguments);
		},

		/**
		 * @override
		 * disable the checkbox based on the styles
		 */
		onSetDefaultValue(field, store, value) {
			this.inherited(arguments);

			if (ID_PARAMETER_FOR_STYLE === field.idParameter) {
				const styleUrls = field.getValue();
				const cache = this.getCache();

				const containsFDDStyles = styleUrls.some((styleUrl) => {
					const style = cache.get(styleUrl);
					return ProductType.isFDDProduct(style);
				});

				if (containsFDDStyles) {
					const createQuoteField = this.getField(this.FIELD_CREATE_QUOTES);
					this.setFieldDisabled(createQuoteField, true);
					this.setFieldValue(createQuoteField, false);
				}
			}
		},

		_buildField: function(/*Context*/ctx, /*Field*/field, /*DOMNode*/tr, /*DOMNode?*/tdControl) {
			var control = this.inherited(arguments);
			var name = field.getControlName();

			// If no active Theme PA has a Supplier then “Create Supplier Quotes” is initialized False and greyed out.  Else initialize True and editable
			if ((name == this.FIELD_CREATE_QUOTES)) {
				var paSpecHasSupplier = this._someThemePAsHasSupplier();
				this.setFieldDisabled(field, !paSpecHasSupplier);
				this.setFieldValue(field, paSpecHasSupplier);
			}

			return control;
		},

		_onChangeProductAlternatives: function(/*csi.def.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update fields based on Product Alternatives
			var themePA = (value == csi.EMPTY_URL) ? null : this.cacheView.getNode(value, true);
			this._updateFieldsFromProductAlternatives(defView, themePA);
		},

		_updateFieldsFromProductAlternatives: function(/*csi.def.View*/defView, /*Node*/themePA) {
			var createQuoteField = this.defView.getField(this.FIELD_CREATE_QUOTES);
			if (!createQuoteField)
				return;

			var canCreateQuotes;
			var defaultCreateQuotes
			if (themePA) {
				var paSpec = this.getCache().getNode(themePA.ThemePASpec, true);

				canCreateQuotes = xml.isValidURL(themePA.ThemePASupplier);
				defaultCreateQuotes = canCreateQuotes && (paSpec.SupplierQuoteExpected);
			} else {
				//When "Theme Product Alternatives" field is <All>
				canCreateQuotes = this._someThemePAsHasSupplier();
				defaultCreateQuotes = canCreateQuotes;
			}

			this.setFieldDisabled(createQuoteField, !canCreateQuotes);
			this.setFieldValue(createQuoteField, defaultCreateQuotes);
		},

		_someThemePAsHasSupplier: function() {
			var theme = this.defView.m_formData.getParent();
			var themePAs = theme.ThemeProductAlternatives;

			var hasSupplier = array.some(themePAs, function(tpa) {
				var paNode = resolver.resolveNode(tpa, true);
				if (!paNode.Active)
					return false;
				return xml.isValidURL(paNode.ThemePASupplier);
			});

			return hasSupplier;
		}
	});
});